var map = {
	"./arrow-white": 4963,
	"./arrow-white.png": 4963,
	"./basket-icon": 3600,
	"./basket-icon.png": 3600,
	"./brand_preview_banner": 4693,
	"./brand_preview_banner.png": 4693,
	"./breadcrumbs-basket": 7559,
	"./breadcrumbs-basket.png": 7559,
	"./breadcrumbs-confirm": 4417,
	"./breadcrumbs-confirm.png": 4417,
	"./breadcrumbs-delivery": 6833,
	"./breadcrumbs-delivery.png": 6833,
	"./breadcrumbs-fasttrack": 6322,
	"./breadcrumbs-fasttrack.png": 6322,
	"./breadcrumbs-nametag": 9506,
	"./breadcrumbs-nametag.png": 9506,
	"./breadcrumbs-payment": 6007,
	"./breadcrumbs-payment.png": 6007,
	"./close-kv": 4900,
	"./close-kv.jpg": 4900,
	"./contact-us-email": 1056,
	"./contact-us-email.png": 1056,
	"./contact-us-school": 4614,
	"./contact-us-school.png": 4614,
	"./dpd-banner": 6165,
	"./dpd-banner.png": 6165,
	"./eco-heart": 4856,
	"./eco-heart.png": 4856,
	"./fasttrack-banner": 7424,
	"./fasttrack-banner.jpg": 7424,
	"./header-bg": 2769,
	"./header-bg.jpg": 2769,
	"./icon-year-current": 3927,
	"./icon-year-current.png": 3927,
	"./icon-year-next": 8685,
	"./icon-year-next.png": 8685,
	"./main-nav-kit": 7286,
	"./main-nav-kit.png": 7286,
	"./main-nav-vouchers": 1489,
	"./main-nav-vouchers.png": 1489,
	"./mastercard-curved-64px": 5795,
	"./mastercard-curved-64px.png": 5795,
	"./measurements-help-tutorial-thumb": 4717,
	"./measurements-help-tutorial-thumb.png": 4717,
	"./nametag-box": 7843,
	"./nametag-box.png": 7843,
	"./nametag-frame": 5143,
	"./nametag-frame.png": 5143,
	"./newsletter-kv": 7217,
	"./newsletter-kv.jpg": 7217,
	"./page-bg": 9267,
	"./page-bg.jpg": 9267,
	"./passwordstrength": 4366,
	"./passwordstrength.jpg": 4366,
	"./payment-icon-cirrus": 1533,
	"./payment-icon-cirrus.png": 1533,
	"./payment-icon-clearpay": 8826,
	"./payment-icon-clearpay.png": 8826,
	"./payment-icon-klarna": 4006,
	"./payment-icon-klarna.png": 4006,
	"./payment-icon-maestro": 4166,
	"./payment-icon-maestro.png": 4166,
	"./payment-icon-mastercard": 6689,
	"./payment-icon-mastercard.png": 6689,
	"./payment-icon-paypal": 1840,
	"./payment-icon-paypal.png": 1840,
	"./payment-icon-visa": 8246,
	"./payment-icon-visa.png": 8246,
	"./question-mark": 9286,
	"./question-mark.png": 9286,
	"./royal_mail_label": 7008,
	"./royal_mail_label.jpg": 7008,
	"./sb-logo": 9953,
	"./sb-logo.png": 9953,
	"./sb_start_rite_1024": 5149,
	"./sb_start_rite_1024.jpg": 5149,
	"./sb_start_rite_1024_green": 4593,
	"./sb_start_rite_1024_green.png": 4593,
	"./sb_start_rite_1024_red": 6433,
	"./sb_start_rite_1024_red.png": 6433,
	"./sb_start_rite_1900": 562,
	"./sb_start_rite_1900.jpg": 562,
	"./sb_start_rite_1900_green": 8242,
	"./sb_start_rite_1900_green.png": 8242,
	"./sb_start_rite_1900_red": 2902,
	"./sb_start_rite_1900_red.png": 2902,
	"./sb_start_rite_666": 3708,
	"./sb_start_rite_666.jpg": 3708,
	"./sb_start_rite_666_green": 5788,
	"./sb_start_rite_666_green.png": 5788,
	"./sb_start_rite_666_red": 2536,
	"./sb_start_rite_666_red.png": 2536,
	"./scb-question-mark": 4317,
	"./scb-question-mark.png": 4317,
	"./silhouette/silhouettes-ankle": 5990,
	"./silhouette/silhouettes-ankle.png": 5990,
	"./silhouette/silhouettes-arm": 1901,
	"./silhouette/silhouettes-arm-length": 2372,
	"./silhouette/silhouettes-arm-length.png": 2372,
	"./silhouette/silhouettes-arm.png": 1901,
	"./silhouette/silhouettes-below-knee": 2030,
	"./silhouette/silhouettes-below-knee.png": 2030,
	"./silhouette/silhouettes-chest": 2996,
	"./silhouette/silhouettes-chest.png": 2996,
	"./silhouette/silhouettes-figure": 9163,
	"./silhouette/silhouettes-figure.png": 9163,
	"./silhouette/silhouettes-height": 8370,
	"./silhouette/silhouettes-height.png": 8370,
	"./silhouette/silhouettes-hip": 2824,
	"./silhouette/silhouettes-hip.png": 2824,
	"./silhouette/silhouettes-inside-leg": 7796,
	"./silhouette/silhouettes-inside-leg.png": 7796,
	"./silhouette/silhouettes-mid-calf": 2962,
	"./silhouette/silhouettes-mid-calf.png": 2962,
	"./silhouette/silhouettes-neck": 1090,
	"./silhouette/silhouettes-neck.png": 1090,
	"./silhouette/silhouettes-on-the-knee": 7668,
	"./silhouette/silhouettes-on-the-knee.png": 7668,
	"./silhouette/silhouettes-shoe-size": 5978,
	"./silhouette/silhouettes-shoe-size.png": 5978,
	"./silhouette/silhouettes-waist": 7027,
	"./silhouette/silhouettes-waist-to-knee": 1477,
	"./silhouette/silhouettes-waist-to-knee.png": 1477,
	"./silhouette/silhouettes-waist.png": 7027,
	"./squadkit-logo": 5922,
	"./squadkit-logo.png": 5922,
	"./startrite-red-1024": 9370,
	"./startrite-red-1024.png": 9370,
	"./startrite-red-1900": 8925,
	"./startrite-red-1900.png": 8925,
	"./startrite-red-666": 8877,
	"./startrite-red-666.png": 8877,
	"./summary-icon-delivery": 1247,
	"./summary-icon-delivery.png": 1247,
	"./summary-icon-fasttrack": 256,
	"./summary-icon-fasttrack.png": 256,
	"./summary-icon-nametag": 1620,
	"./summary-icon-nametag.png": 1620,
	"./van": 2839,
	"./van.png": 2839,
	"./welcome-bg": 1042,
	"./welcome-bg.jpg": 1042,
	"./welcome-icons-covid": 1265,
	"./welcome-icons-covid.png": 1265,
	"./welcome-icons-order": 6166,
	"./welcome-icons-order.png": 6166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2829;